import HintModal from './HintModal';

export default HintModal;